import { styled } from "@health-zelas/delta"

export const TextBlock = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',

  '@md': {
    alignItems: 'start',
    textAlign: 'left',
  }
})
